import type { QueryClient } from '@tanstack/react-query';
import { fetchCatalogJob } from './jobs-api';
import { QUERY_KEYS } from './query-keys';
import {
  getCatalogJobIdFromNotificationTarget,
  resolveNotificationTarget,
} from './notification-target';

const JOB_DETAIL_STALE_TIME_MS = 30_000;

/**
 * Starts the job-detail request before the notification route transition. The
 * detail hook uses the same key, so React Query shares both cached and in-flight
 * work rather than issuing a second request after the screen mounts.
 */
export async function prefetchNotificationJobDetail(
  queryClient: QueryClient,
  data: unknown,
) {
  const jobId = getCatalogJobIdFromNotificationTarget(
    resolveNotificationTarget(data),
  );
  if (!jobId) return;

  await queryClient.prefetchQuery({
    queryKey: QUERY_KEYS.JOB_CATALOG_DETAIL(jobId),
    queryFn: () => fetchCatalogJob(jobId),
    staleTime: JOB_DETAIL_STALE_TIME_MS,
  });
}
